// extracted by mini-css-extract-plugin
export default {"wrap":"LO-z","fullWidth":"MO-z","hideOnDesktop":"NO-z","content":"OO-z","hasOpenedNav":"PO-z","crumbsList":"QO-z","dropdownsWrap":"RO-z"};